import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../../Dispute/SectionWrapper';
import InfoText from '../../atoms/InfoText';
import Avatar from '../../atoms/Avatar';
import classNames from 'classnames';
import { Table } from 'antd';
import { useParams } from 'react-router-dom';
import { useGetSellerInfoDisputeQuery } from '../../../store/services/disputeService';

export default function AboutSeller() {
  const { t } = useTranslation();

  const params = useParams();

  const { data } = useGetSellerInfoDisputeQuery({
    disputeId: params?.disputeId,
  });

  const columns = [
    { title: '', dataIndex: 'name', key: 'name' },
    {
      title: '',
      dataIndex: 'value',
      key: 'value',
      className: 'text-end font-semibold',
    },
  ];

  const dataSource = [
    {
      name: 'Total orders',
      value: data?.payload?.totalOrders,
    },

    {
      name: 'Phone number',
      value: data?.payload?.phone,
    },

    {
      name: 'Email',
      value: data?.payload?.email,
    },
  ];

  return (
    <SectionWrapper title={t('components.disputeFeature.moreDetailsSupplier')}>
      <>
        <div
          data-testid="store-order-details-customer-avatar"
          className="space-y-1"
        >
          <InfoText text={t('components.disputeFeature.supplierDetails')} />

          <Avatar
            title={data?.payload?.name}
            image={data?.payload?.image}
            imageSize={16}
          />
        </div>

        <Table
          columns={columns}
          className="customTable"
          dataSource={dataSource}
          pagination={false}
          showHeader={false}
          size="middle"
        />
      </>
    </SectionWrapper>
  );
}

export const Box = ({
  name,
  value,
  currency,
  isTotal,
}: {
  name: string;
  value?: string;
  currency?: string;
  isTotal?: boolean;
}) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-between px-2 py-4',
        isTotal && 'bg-[#FEF6F2] dark:bg-[#F58F291A]'
      )}
    >
      <InfoText
        text={name}
        className={classNames(
          '!text-light-text-primary dark:!text-dark-text-primary',
          isTotal && '!font-bold'
        )}
      />
      <div className="flex items-center gap-1">
        <InfoText
          text={value || '-'}
          className="!text-light-text-primary !font-bold dark:!text-dark-text-primary"
        />

        {currency && (
          <InfoText
            text={currency}
            size="xs"
            className="!text-light-text-primary dark:!text-dark-text-primary"
          />
        )}
      </div>
    </div>
  );
};
